
    <h1>{{ organizationDetails.OrganizationName }}</h1>
      <h2 (click)="goToNextPage()">Thank you! Your ${{ organizationDetails.ChargeAmount }} payment
        was successful!</h2>
    <div class="full-width text-align-middle link cursor" (click)="login()">Log into my account</div>
